import { render } from "./Workers.vue?vue&type=template&id=1a1d9674"
import script from "./Workers.vue?vue&type=script&lang=js"
export * from "./Workers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__